import { BRAND_SECONDARY } from "../../../utils/Styles";
import * as React from "react";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import { useParams, useHistory } from "react-router-dom";
import {
  IDropdownOption,
  Stack,
  DefaultButton,
  PrimaryButton,
  DayOfWeek,
  DatePicker,
  Dropdown,
  Checkbox,
  Breadcrumb,
  DropdownMenuItemType,
  ISelectableOption,
  Callout,
  DirectionalHint,
} from "office-ui-fabric-react";
import {
  IDataCenter,
  ISMPSReading,
  ISearchSmps,
  IReadingStatus,
  IFloorVM,
} from "../../../vm";
import {
  getADataCenter,
  getFloorsWhichHasUnits,
  getPowerComponents,
} from "../../../services/datacenter/DatacenterService";
import {
  getSmpsList,
  getSmpsReadings,
  updateSmpsReadingStatus,
} from "../../../services/infrastructure/SmpsService";
import moment from "moment";
import NoDataTile from "../../common/NoDataTile";
import { Loading } from "../../../services/Loading";
import {
  childrenGap,
  ODD_SHIFT,
  UPS_STATUS,
  READ_AT_TIME_FORMAT,
  childrenGap8,
  EVEN_SHIFT,
} from "../../common/Constants";
import Icon from "@mdi/react";
import { mdiChevronLeft, mdiChevronRight, mdiDotsVertical } from "@mdi/js";
import ManageSmpsDialog from "./ManageSmpsDialog";
import {
  getThreshold,
  isInThreshold,
  isValueLessThanThreshold,
} from "../../../services/ThresholdService";
import ManageAllRejectDialog from "../../common/ManageAllRejectDialog";
import ShowThresholdIcon from "../../common/ShowThresholdIcon";

export interface SmpsMainProps { }

const SmpsMain: React.FC<SmpsMainProps> = () => {
  //state
  const [state, setState] = React.useState({
    isLoading: false,
    isDatacenterFound: false,
    isSmpsLoaded: false,
    smpsList: [],
    allSmpsDropdownList: [],
    allFloorsDropdownList: [],
    datacenter: undefined,
    searchObj: { datacenterId: "", date: new Date(), smpsId: "", floorId: "" },
    smpsReading: [],
    isIndeterminate: false,
    isAllChecked: false,
    selectedItems: [],
    smpsObj: {},
    manageSmpsDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    threshold: undefined,
    manageRejectDialog: {
      isOpen: false,
      ids: [],
      remarks: "",
    },
    manageActionsCallout: {
      isOpen: false,
      element: undefined,
      data: undefined,
    },
  } as {
    isLoading: boolean;
    isDatacenterFound: boolean;
    isSmpsLoaded: boolean;
    smpsList: any[];
    allSmpsDropdownList: IDropdownOption[];
    allFloorsDropdownList: IDropdownOption[];
    datacenter?: IDataCenter;
    searchObj: ISearchSmps;
    smpsReading: ISMPSReading[];
    isIndeterminate: boolean;
    isAllChecked: boolean;
    selectedItems: string[];
    smpsObj: any;
    manageSmpsDialog: {
      isOpen: boolean;
      index?: number;
      data?: ISMPSReading;
    };
    threshold: any;
    manageRejectDialog: {
      isOpen: boolean;
      ids: string[];
      remarks?: string;
    };
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      data?: ISMPSReading;
    };
  });

  //hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);
  const params: any = useParams();
  const history = useHistory();

  React.useEffect(() => {
    const asyncFunc = async () => {
      if (params.dataCenterId) {
        getDatacenter(params.dataCenterId);
      }
    };
    asyncFunc();
  }, []);

  const getDatacenter = async (datacenterId: string) => {
    setState({ ...state, isLoading: true });
    let result = await getADataCenter(datacenterId);
    if (result?.success) {
      setState({
        ...state,
        datacenter: result.data,
        isDatacenterFound: true,
        isLoading: false,
      });

      getFloorList(result.data);
    } else {
      showToast(result?.message || "Error while getting datacenter", "error");
      setState({ ...state, isDatacenterFound: false, isLoading: false });
    }
  };

  const getFloorList = async (datacenter: IDataCenter) => {
    setState({ ...state, isLoading: true });
    let result = await getFloorsWhichHasUnits({
      dataCenterId: params.dataCenterId,
      type: "smps",
    });
    if (result?.success) {
      let options: IDropdownOption[] = [];
      const floorByBuilding: { [Key: string]: IFloorVM[] } = result.data.reduce(
        (acc: any, d) => {
          if (acc[d.buildingId] == null) {
            acc[d.buildingId] = [];
          }

          acc[d.buildingId].push(d);
          return acc;
        },
        {}
      );
      let temp = Object.keys(floorByBuilding);
      temp.forEach((d, index) => {
        options.push({
          key: d,
          text: floorByBuilding[d][0].buildingName,
          itemType: DropdownMenuItemType.Header,
        });
        floorByBuilding[d].forEach((f) => {
          options.push({
            key: f.floorId,
            text: f.floorName,
            data: { buildingName: f.buildingName },
          });
        });
        if (temp.length != index + 1) {
          options.push({
            key: "divider_1",
            text: "-",
            itemType: DropdownMenuItemType.Divider,
          });
        }
      });

      // console.log("[options]", options);
      // result.data.forEach((ele: any) => {
      //   options.push({
      //     key: ele.floorId,
      //     text: `${ele.buildingName} - ${ele.floorName}`,
      //   });
      // });
      getThresholdData(datacenter, options);
    } else {
      setState({ ...state, isLoading: false });
    }
  };

  const getThresholdData = async (
    datacenter: IDataCenter,
    allFloorsDropdownList: IDropdownOption[]
  ) => {
    setState({ ...state, isLoading: true });
    let result = await getThreshold("smps");
    if (result?.success) {
      getSMPSList(datacenter, allFloorsDropdownList, result.data.threshold);
    } else {
      showToast(result?.message || "Error while getting datacenter", "error");
      setState({ ...state, isDatacenterFound: false, isLoading: false });
    }
  };
  // before it was smps list now it is power components
  const getSMPSList = async (
    datacenter: IDataCenter,
    allFloorsDropdownList: IDropdownOption[],
    threshold?: any
  ) => {
    setState({ ...state, isLoading: true });
    let result = await getPowerComponents({
      datacenterId: params.dataCenterId,
      types: ["smps"],
    });
    if (result?.success) {
      let smpsObj = result.data.reduce((acc, ele) => {
        // if (acc[ele.quadrantId.floorId] == null) {
        //   acc[ele.quadrantId.floorId] = [];
        // }
        if (acc[ele.floorId] == null) {
          acc[ele.floorId] = [];
        }
        // acc[ele.quadrantId.floorId].push({
        //   key: ele._id,
        //   text: `${ele?.quadrantId?.quadrant} - ${ele?.coldAisle?.tileText}`,
        // });
        acc[ele.floorId].push({ key: ele._id, text: ele.name });
        return acc;
      }, {});
      let obj = {
        ...state,
        smpsList: result.data,
        isLoading: false,
        datacenter,
        isDatacenterFound: true,
        searchObj: {
          datacenterId: params.dataCenterId,
          date: new Date(),
          smpsId:
            allFloorsDropdownList.length > 1 &&
              smpsObj[allFloorsDropdownList[1].key as string]
              ? smpsObj[allFloorsDropdownList[1].key as string][0].key
              : "",
          floorId:
            allFloorsDropdownList.length > 1
              ? (allFloorsDropdownList[1].key as string)
              : "",
        },
        smpsObj,
        allFloorsDropdownList,
        allSmpsDropdownList:
          (allFloorsDropdownList.length > 1 &&
            smpsObj[allFloorsDropdownList[1].key as string]) ||
          [],
        threshold,
      };
      setState(obj);
      getSmpsReadingsData(obj);
    } else {
      showToast(result?.message || "Error while getting smps list", "error");
      setState({ ...state, isLoading: false });
    }
  };

  const getSmpsReadingsData = async (paramState?: any) => {
    let localState = { ...state };
    if (paramState != null) {
      localState = { ...paramState };
    }
    setState({ ...localState, isLoading: true });
    let obj = { ...localState.searchObj };
    obj.date = moment(obj.date).format("YYYY-MM-DD");
    let result = await getSmpsReadings(obj);
    if (result?.success) {
      setState({
        ...localState,
        smpsReading: result.data,
        isLoading: false,
        isSmpsLoaded: true,
      });
    } else {
      showToast(
        result?.message || "Error while getting smps readings",
        "error"
      );
      setState({ ...state, isLoading: false, isSmpsLoaded: false });
    }
  };

  const onSearch = async () => {
    if (!state.searchObj.floorId) {
      showToast("Please select a floor before searching", "error");
      return;
    }
    if (!state.searchObj.smpsId) {
      showToast("Please select an smps before searching", "error");
      return;
    }
    getSmpsReadingsData();
  };

  const handleAcceptOrReject = (id: string, isAccept: boolean) => {
    showConfirmDialog(
      "Are You Sure",
      `Do you want to ${isAccept ? "Accept" : "Reject"} the smps reading`,
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            element: undefined,
            data: undefined,
          },
        });
        let obj: IReadingStatus = {
          ids: [id],
          status: isAccept ? "approved" : "rejected",
        };
        let result = await updateSmpsReadingStatus(obj);
        if (result?.success) {
          let smpsReading = [...state.smpsReading];
          let index = smpsReading.findIndex((ele) => ele._id === id);
          if (index !== -1) {
            smpsReading[index].status = isAccept ? "approved" : "rejected";
          }
          let selectedItems = [...state.selectedItems];
          let indexToRemove = selectedItems.findIndex((ele) => ele === id);
          if (index !== -1) {
            selectedItems.splice(indexToRemove, 1);
          }
          showToast(
            `SMPS Reading ${isAccept ? "approved" : "rejected"} successfully`,
            "success"
          );
          setState({
            ...state,
            smpsReading,
            selectedItems,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          showToast(
            result?.message ||
            `An error occurred while ${isAccept ? "approving" : "rejecting"
            } a smps reading`,
            "error"
          );
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              element: undefined,
              data: undefined,
            },
          });
        }
      }
    );
  };

  const handleAcceptOrRejectSelected = (isAccept: boolean) => {
    if (isAccept) {
      showConfirmDialog(
        "Are You Sure",
        `Do you want to ${isAccept ? "Accept" : "Reject"
        } selected smps reading`,
        async () => {
          let selectedItems = [...state.selectedItems];
          let smpsReading = [...state.smpsReading];
          setState({
            ...state,
            isLoading: true,
          });
          let obj: IReadingStatus = {
            ids: selectedItems,
            status: isAccept ? "approved" : "rejected",
          };
          let result = await updateSmpsReadingStatus(obj);
          if (result?.success) {
            selectedItems.forEach((item) => {
              let index = smpsReading.findIndex((ele) => ele._id === item);
              if (index !== -1) {
                smpsReading[index].status = isAccept ? "approved" : "rejected";
              }
            });
            showToast(
              `SMPS Reading ${isAccept ? "approved" : "rejected"} successfully`,
              "success"
            );
            setState({
              ...state,
              smpsReading,
              selectedItems: [],
              isLoading: false,
            });
          } else {
            showToast(
              result?.message ||
              `An error occurred while ${isAccept ? "approving" : "rejecting"
              } a smps reading`,
              "error"
            );
            setState({
              ...state,
              isLoading: false,
            });
          }
        }
      );
    } else {
      let selectedItems = [...state.selectedItems];
      handleRejectAllOpenDialog(selectedItems);
    }
  };

  const onSelectAll = (isAllChecked: boolean) => {
    let selectedItems: string[] = [];
    if (isAllChecked) {
      state.smpsReading.forEach((ele) => {
        if (ele.status === "submitted") {
          selectedItems.push(ele._id as string);
        }
      });
      setState({ ...state, isAllChecked: true, selectedItems });
    } else {
      setState({ ...state, isAllChecked: false, selectedItems });
    }
  };

  const onIndividualSelect = (id: string) => {
    let selectedItems = [...state.selectedItems];
    let index = selectedItems.findIndex((e) => e === id);
    if (index === -1) {
      selectedItems.push(id);
    } else {
      selectedItems.splice(index, 1);
    }
    let isAllChecked = true;
    state.smpsReading.forEach((ele) => {
      if (
        ele.status === "submitted" &&
        selectedItems.includes(ele._id as string) === false
      ) {
        isAllChecked = false;
      }
    });
    setState({ ...state, selectedItems, isAllChecked });
  };

  const getMinValue = (property: string) => {
    let a = property.split(".");
    if (state.smpsReading.length > 0) {
      let list = state.smpsReading.map((ele: any) => {
        if (a[1]) {
          return ele[a[0]] ? ele[a[0]][a[1]] : "";
        } else {
          return ele[a[0]];
        }
      });
      return Math.min(...list);
    } else {
      return "";
    }
  };
  const getMaxValue = (property: string) => {
    let a = property.split(".");
    if (state.smpsReading.length > 0) {
      let list = state.smpsReading.map((ele: any) => {
        if (a[1]) {
          return ele[a[0]] ? ele[a[0]][a[1]] : "";
        } else {
          return ele[a[0]];
        }
      });
      return Math.max(...list);
    } else {
      return "";
    }
  };

  const handleOpenDialog = (isOpen: boolean, id?: string) => {
    let smpsReadingItem = undefined;
    let index = undefined;
    if (id !== undefined) {
      let smpsReadingList = [...state.smpsReading];
      index = smpsReadingList.findIndex((e) => e._id === id);
      smpsReadingItem = { ...state.smpsReading[index] };
    }
    setState({
      ...state,
      manageSmpsDialog: {
        isOpen: isOpen,
        index: index,
        data: smpsReadingItem,
      },
    });
  };

  const handleCloseDialog = (data: ISMPSReading) => {
    let smpsReading = [...state.smpsReading];
    if (data) {
      if (state.manageSmpsDialog.index !== undefined) {
        smpsReading[state.manageSmpsDialog.index] = data;
      }
    }
    setState({
      ...state,
      manageSmpsDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      smpsReading,
    });
  };

  const handleRejectAllOpenDialog = (ids: string[]) => {
    setState({
      ...state,
      manageRejectDialog: {
        isOpen: true,
        ids: ids || [],
        remarks: "",
      },
    });
  };
  const handleRejectOpenDialog = (id: string, remarks?: string) => {
    setState({
      ...state,
      manageRejectDialog: {
        isOpen: true,
        ids: [id],
        remarks: remarks || "",
      },
    });
  };

  const handleRejectCloseDialog = async (
    isSuccess: boolean,
    remarks?: string
  ) => {
    let smpsReading = [...state.smpsReading];
    let selectedItems: string[] = state.manageRejectDialog.ids;
    if (isSuccess) {
      setState({
        ...state,
        isLoading: true,
      });
      let obj: IReadingStatus = {
        ids: selectedItems,
        status: "rejected",
        remarks: remarks || "",
      };
      let result = await updateSmpsReadingStatus(obj);
      if (result?.success) {
        selectedItems.forEach((item) => {
          let index = smpsReading.findIndex((ele) => ele._id === item);
          if (index !== -1) {
            smpsReading[index].status = "rejected";
            smpsReading[index].remarks = remarks || "";
          }
        });
        showToast(`SMPS Reading rejected successfully`, "success");
        setState({
          ...state,
          smpsReading,
          selectedItems: [],
          manageRejectDialog: {
            isOpen: false,
            ids: [],
            remarks: undefined,
          },
          isLoading: false,
        });
      } else {
        showToast(
          result?.message || `An error occurred while rejecting a smps reading`,
          "error"
        );
        setState({
          ...state,
          manageRejectDialog: {
            isOpen: false,
            ids: [],
            remarks: undefined,
          },
          isLoading: false,
        });
      }
    } else {
      setState({
        ...state,
        manageRejectDialog: {
          isOpen: false,
          ids: [],
          remarks: undefined,
        },
        smpsReading,
      });
    }
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const onNextOrPrevFunc = (isPrev: boolean) => {
    let localState = { ...state };

    let currentSelectedFloor = localState.searchObj.floorId;
    let currentFloorList = localState.allFloorsDropdownList;
    let currentSelectedSmps = localState.searchObj.smpsId;
    let currentSmpsList = localState.allSmpsDropdownList;

    let currentSmpsIndex = currentSmpsList.findIndex(
      (d) => d.key === currentSelectedSmps
    );

    if (isPrev) {
      if (currentSmpsIndex !== 0) {
        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            smpsId: currentSmpsList[currentSmpsIndex - 1].key as string,
          },
        };
      } else {
        let currentFloorIndex = currentFloorList.findIndex(
          (d) => d.key === currentSelectedFloor
        );
        if (currentFloorIndex === 1) return;
        let currentFloor = currentFloorList[currentFloorIndex - 1];
        if (currentFloor.itemType) {
          // this is due to divider and header
          currentFloor = currentFloorList[currentFloorIndex - 3];
        }
        currentSelectedFloor = currentFloor.key as string;

        currentSmpsList = localState.smpsObj[currentSelectedFloor];

        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            floorId: currentSelectedFloor,
            smpsId: currentSmpsList[currentSmpsList.length - 1].key as string,
          },
          allSmpsDropdownList: currentSmpsList,
        };
      }
    } else {
      if (currentSmpsIndex !== currentSmpsList.length - 1) {
        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            smpsId: currentSmpsList[currentSmpsIndex + 1].key as string,
          },
        };
      } else {
        let currentFloorIndex = currentFloorList.findIndex(
          (d) => d.key === currentSelectedFloor
        );
        if (currentFloorIndex === currentFloorList.length - 1) return;
        let currentFloor = currentFloorList[currentFloorIndex + 1];
        if (currentFloor.itemType) {
          // this is due to divider and header
          currentFloor = currentFloorList[currentFloorIndex + 3];
        }
        currentSelectedFloor = currentFloor.key as string;

        currentSmpsList = localState.smpsObj[currentSelectedFloor];

        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            floorId: currentSelectedFloor,
            smpsId: currentSmpsList[0].key as string,
          },
          allSmpsDropdownList: currentSmpsList,
        };
      }
    }
    // console.log("[onNextOrPrevFunc localState]", localState);
    getSmpsReadingsData(localState);
  };

  const onRenderOption = (option?: ISelectableOption): JSX.Element => {
    if (!option) return <div />;
    return (
      <div className="d-flex">
        {/* {!option.itemType && <Icon path={mdiFloorPlan} size={0.8} />} */}
        <span style={{ marginLeft: option.itemType ? "0px" : "12px" }}>
          {option.text}
        </span>
      </div>
    );
  };

  const onRenderTitle = (options?: IDropdownOption[]): JSX.Element => {
    if (!options) return <div />;
    const option = options[0];

    return (
      <div>
        <span>{option.data.buildingName + "-" + option.text}</span>
      </div>
    );
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    data?: ISMPSReading
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        data,
      },
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      {state.isDatacenterFound ? (
        <React.Fragment>
          <Stack>
            <Stack.Item>
              {/* <Text variant="xLarge">
                  SMPS Readings - {state.datacenter && state.datacenter.name}{" "}
                  {state.datacenter && state.datacenter.location && " - "}
                  {state.datacenter && state.datacenter.location}
                </Text> */}
              <Breadcrumb
                items={[
                  {
                    text: state.datacenter
                      ? state.datacenter.name
                      : "Datacenter",
                    key: "datacenter",
                  },
                  {
                    text: "Infrastructures",
                    key: "infrastructure",
                    onClick: () => {
                      history.goBack();
                    },
                  },
                  {
                    text: "SMPS Readings",
                    key: "smps-readings",
                    isCurrentItem: true,
                  },
                ]}
              />
            </Stack.Item>
          </Stack>
          <br />
          <Stack horizontal horizontalAlign="start">
            <Stack.Item>
              <Stack horizontal wrap tokens={childrenGap}>
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a Floor"
                    // defaultSelectedKey={state.searchObj.floorId}
                    onRenderOption={onRenderOption}
                    onRenderTitle={onRenderTitle}
                    selectedKey={state.searchObj.floorId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.allFloorsDropdownList}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            floorId: v.key as string,
                            // customerRackId: "",
                            smpsId:
                              (state.smpsObj[v.key] &&
                                state.smpsObj[v.key][0].key) ||
                              "",
                          },
                          allSmpsDropdownList: state.smpsObj[v.key],
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a SMPS"
                    // label="Role"
                    // defaultSelectedKey={state.searchObj.customerRackId}
                    selectedKey={state.searchObj.smpsId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.allSmpsDropdownList}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            smpsId: v.key as string,
                          },
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <DatePicker
                    firstDayOfWeek={DayOfWeek.Sunday}
                    showMonthPickerAsOverlay={true}
                    value={new Date(state.searchObj.date)}
                    showGoToToday={false}
                    onSelectDate={(date: Date | null | undefined) =>
                      setState({
                        ...state,
                        searchObj: { ...state.searchObj, date: date as Date },
                      })
                    }
                    placeholder="Select a date..."
                    ariaLabel="Select a date"
                    styles={{ root: { width: 200 } }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={() => onSearch()} />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            {/* <Stack.Item>
              <DefaultButton
                className="mr-8"
                text="Accept"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
              />
            </Stack.Item> */}
          </Stack>
          <br />
          <Stack horizontal horizontalAlign="space-between" wrap>
            <Stack.Item className="ml-6">
              <span
                onClick={
                  state.allFloorsDropdownList.length < 2 ||
                    (state.allFloorsDropdownList[1]?.key ===
                      state.searchObj.floorId &&
                      state.allSmpsDropdownList[0]?.key ===
                      state.searchObj.smpsId)
                    ? undefined
                    : () => onNextOrPrevFunc(true)
                }
                className={
                  state.allFloorsDropdownList.length < 2 ||
                    (state.allFloorsDropdownList[1]?.key ===
                      state.searchObj.floorId &&
                      state.allSmpsDropdownList[0]?.key ===
                      state.searchObj.smpsId)
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <Icon
                  path={mdiChevronLeft}
                  size={0.9}
                  className="btnIcon"
                  style={{
                    marginBottom: -6,
                    marginRight: -8,
                    color: BRAND_SECONDARY,
                  }}
                />
                <DefaultButton
                  text="Previous SMPS"
                  className="borderless-btn"
                // disabled={
                // state.allFloorsDropdownList[1].key ===
                //   state.searchObj.floorId &&
                // state.allSmpsDropdownList[0].key ===
                //   state.searchObj.customerRackId
                //   }
                // onClick={() => {
                //   onNextOrPrevFunc(true);
                // }}
                />
              </span>
              <span className="nxt-prv-btn-border"></span>
              <span
                onClick={
                  state.allFloorsDropdownList.length < 2 ||
                    (state.allFloorsDropdownList[
                      state.allFloorsDropdownList.length - 1
                    ]?.key === state.searchObj.floorId &&
                      state.allSmpsDropdownList[
                        state.allSmpsDropdownList.length - 1
                      ]?.key === state.searchObj.smpsId)
                    ? undefined
                    : () => onNextOrPrevFunc(false)
                }
                className={
                  state.allFloorsDropdownList.length < 2 ||
                    (state.allFloorsDropdownList[
                      state.allFloorsDropdownList.length - 1
                    ]?.key === state.searchObj.floorId &&
                      state.allSmpsDropdownList[
                        state.allSmpsDropdownList.length - 1
                      ]?.key === state.searchObj.smpsId)
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <DefaultButton
                  text="Next SMPS"
                  // disabled={
                  // state.allFloorsDropdownList[
                  //     state.allFloorsDropdownList.length - 1
                  //   ].key === state.searchObj.floorId &&
                  //   state.allSmpsDropdownList[
                  //     state.allSmpsDropdownList.length - 1
                  //   ].key === state.searchObj.customerRackId
                  // }
                  // onClick={() => {
                  //   onNextOrPrevFunc(false);
                  // }}
                  className="borderless-btn"
                />
                <Icon
                  path={mdiChevronRight}
                  size={0.9}
                  className="btnIcon"
                  style={{ marginBottom: -6, marginLeft: -8, color: BRAND_SECONDARY }}
                />
              </span>
            </Stack.Item>
            <Stack.Item>
              <DefaultButton
                text="Accept"
                className="mr-8 custom-secondary-btn"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
                className="custom-secondary-btn"
              />
            </Stack.Item>
          </Stack>
          {/* <Stack horizontal horizontalAlign="end" wrap>
            <Stack.Item>
              <DefaultButton
                text="Accept"
                className="mr-8"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
            </Stack.Item>
            <Stack.Item>
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
              />
            </Stack.Item>
          </Stack> */}
          <br />
          {state.isSmpsLoaded && (
            <Stack>
              <div className="office-table bg-white">
                <table className="ms-Table bordered-table w-100">
                  <thead className="html-table-thead">
                    <tr>
                      <th rowSpan={2}>
                        <Checkbox
                          //   indeterminate={state.isIndeterminate}
                          checked={state.isAllChecked}
                          onChange={(eve, checked) =>
                            onSelectAll(checked as boolean)
                          }
                        />
                      </th>
                      <th rowSpan={2}>Time (Hrs)</th>
                      <th rowSpan={2}>System</th>
                      <th colSpan={2}>SMPS</th>
                      <th rowSpan={2}>SMPS Room Temp ℃</th>
                      <th rowSpan={2}>Battery Room Temp ℃</th>
                      <th rowSpan={2}>Shift Tech Sign</th>
                      <th rowSpan={2}>Status</th>
                      <th rowSpan={2}>Remarks</th>
                      <th rowSpan={2}>Read At</th>
                      <th rowSpan={2}>Actions</th>
                    </tr>
                    <tr>
                      <th>DC Volt</th>
                      <th>DC Amps</th>
                    </tr>
                  </thead>
                  <tbody>
                    {EVEN_SHIFT.map((ele, index) => {
                      let item = state.smpsReading.find(
                        (e) => e.shiftTime === ele
                      );
                      return (
                        <tr key={index}>
                          <th>
                            <Checkbox
                              disabled={!item || item.status !== "submitted"}
                              checked={state.selectedItems.includes(
                                item?._id as string
                              )}
                              onChange={() =>
                                onIndividualSelect(item?._id as string)
                              }
                              className="ml-12"
                            />
                          </th>
                          <th> {ele} </th>
                          <td>
                            {item?.isSystemOn !== undefined
                              ? item?.isSystemOn === true
                                ? "On"
                                : "Off"
                              : ""}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.dcVolt || "",
                                "dcVolt",
                                state.threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.dcVolt || ""}
                            {isInThreshold(
                              item?.dcVolt || "",
                              "dcVolt",
                              state.threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.dcVolt || "",
                                      "dcVolt",
                                      state.threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.dcAmps || "",
                                "dcAmps",
                                state.threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.dcAmps || ""}
                            {isInThreshold(
                              item?.dcAmps || "",
                              "dcAmps",
                              state.threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.dcAmps || "",
                                      "dcAmps",
                                      state.threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.roomTemp || "",
                                "roomTemp",
                                state.threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.roomTemp || ""}
                            {isInThreshold(
                              item?.roomTemp || "",
                              "roomTemp",
                              state.threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.roomTemp || "",
                                      "roomTemp",
                                      state.threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.batteryRoomTemp || "",
                                "batteryRoomTemp",
                                state.threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.batteryRoomTemp || ""}
                            {isInThreshold(
                              item?.batteryRoomTemp || "",
                              "batteryRoomTemp",
                              state.threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.batteryRoomTemp || "",
                                      "batteryRoomTemp",
                                      state.threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td>{item?.recordedBy || ""}</td>
                          <td>
                            {item && item.status ? UPS_STATUS[item.status] : ""}
                          </td>
                          <td>{item?.remarks || ""}</td>
                          <td>
                            {item?.date
                              ? moment(item.date).format(READ_AT_TIME_FORMAT)
                              : ""}
                          </td>
                          <td align="center" className="no-wrap">
                            {item && item.status === "submitted" && (
                              <span
                                onClick={(ele) =>
                                  handleCallOutOpenClose(true, ele, item)
                                }
                              >
                                <Icon
                                  path={mdiDotsVertical}
                                  size={0.9}
                                  className="pointer"
                                  color={BRAND_SECONDARY}
                                />
                              </span>
                              // <React.Fragment>
                              //   <TooltipHost
                              //     content="Update"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleOpenDialog(true, item?._id)
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiPencil}
                              //         size={0.7}
                              //         className="pointer"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              //   &nbsp;&nbsp;
                              //   <TooltipHost
                              //     content="Accept"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleAcceptOrReject(
                              //           item?._id as string,
                              //           true
                              //         )
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiCheck}
                              //         size={0.8}
                              //         className="pointer"
                              //         color="green"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              //   &nbsp;&nbsp;
                              //   <TooltipHost
                              //     content="Reject"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleRejectOpenDialog(
                              //           item?._id as string,
                              //           item?.remarks
                              //         )
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiClose}
                              //         size={0.8}
                              //         className="pointer"
                              //         color="red"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              // </React.Fragment>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td></td>
                      <th>Min Value</th>
                      <td></td>
                      <td>{getMinValue("dcVolt")}</td>
                      <td>{getMinValue("dcAmps")}</td>
                      <td>{getMinValue("roomTemp")}</td>
                      <td>{getMinValue("batteryRoomTemp")}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <th>Max Value</th>
                      <td></td>
                      <td>{getMaxValue("dcVolt")}</td>
                      <td>{getMaxValue("dcAmps")}</td>
                      <td>{getMaxValue("roomTemp")}</td>
                      <td>{getMaxValue("batteryRoomTemp")}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* <div className="next-prev-btn">
                <div>
                  <DefaultButton
                    text="Previous SMPS"
                    className="mr-8"
                    disabled={
                      state.allFloorsDropdownList[1].key ===
                        state.searchObj.floorId &&
                      state.allSmpsDropdownList[0].key ===
                        state.searchObj.customerRackId
                    }
                    onClick={() => {
                      onNextOrPrevFunc(true);
                    }}
                  />
                  <DefaultButton
                    text="Next SMPS"
                    disabled={
                      state.allFloorsDropdownList[
                        state.allFloorsDropdownList.length - 1
                      ].key === state.searchObj.floorId &&
                      state.allSmpsDropdownList[
                        state.allSmpsDropdownList.length - 1
                      ].key === state.searchObj.customerRackId
                    }
                    onClick={() => {
                      onNextOrPrevFunc(false);
                    }}
                  />
                </div>
              </div> */}
            </Stack>
          )}
        </React.Fragment>
      ) : (
        <NoDataTile
          title="No Datacenter Found"
          description="Datacenter either deleted or not created"
        />
      )}
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleOpenDialog(
                    true,
                    state.manageActionsCallout.data?._id as string
                  )
                }
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleAcceptOrReject(
                    state.manageActionsCallout.data?._id as string,
                    true
                  )
                }
                className="callout-options"
              >
                Accept
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleRejectOpenDialog(
                    state.manageActionsCallout.data?._id as string,
                    state.manageActionsCallout.data?.remarks
                  )
                }
                className="callout-options"
              >
                Reject
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.manageSmpsDialog.isOpen && (
        <ManageSmpsDialog
          closeManageDialog={(data: ISMPSReading) => handleCloseDialog(data)}
          data={state.manageSmpsDialog.data}
          handleLoading={handleLoading}
          threshold={state.threshold}
        />
      )}
      {state.manageRejectDialog.isOpen && (
        <ManageAllRejectDialog
          handleRejectCloseDialog={(isSuccess: boolean, remarks?: string) =>
            handleRejectCloseDialog(isSuccess, remarks)
          }
          remarks={state.manageRejectDialog.remarks}
          subText="smps reading"
        />
      )}
    </React.Fragment>
  );
};

export default SmpsMain;
